import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Router } from '@angular/router';
import { InteractorService } from 'src/app/core/services/interactor.service';
@Component({
  selector: 'app-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.scss'],
})
export class NotificationIconComponent implements OnInit {
  totalNotificationCount = 0;
  IsNavigate = false;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  badgeColor=this.brandingDetails?.branding?.BackgroundColors?.Badge;
  constructor(
    private notificationService: NotificationService,
    private interactorService: InteractorService,
    private router: Router) { }
  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--badgeColor', this.brandingDetails?.branding?.BackgroundColors?.Badge);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--badgeColor', this.brandingDetails?.branding?.BackgroundColors?.Badge);
    this.getNotificationCount();
    this.notificationService.notificationBellCount.subscribe(notificationCount => {
      this.totalNotificationCount = notificationCount;
    });
  }

  goNotification() {
    this.IsNavigate = true;
    this.notificationService.setNotificationBellCount(0);
    this.router.navigate(['/notifications-all']);
  }
  /**
   * Get Total unresolved notifications
   */
  getNotificationCount() {
    this.totalNotificationCount = 0;
    setTimeout(() => {
      this.notificationService.getNotificationCount()
        .subscribe((output: any) => {
          if (output.StatusCode === 200) {
            this.notificationService.setNotificationBellCount(output.Data?.totalCount);
          } else {
            console.warn('error');
          }
        });
    }, 4000);
  }
  setBackgroundColors(){
    this.badgeColor=this.brandingDetails?.branding?.BackgroundColors?.Badge;
  }
}
